<template>
  <div class="site">
    <official-header
      :basic-info="ctx.basicInfo"
      :nav-items="navItems"
      :products="ctx.products"
      :is-mobile="isMobile"
      :compact-header="compactHeader"
      :mobile-drawer-visible="mobileDrawerVisible"
      @change-lang="changeLang"
      @update-mobile-drawer="updateMobileDrawer"
    />
    <router-view />
    <contact-footer :basic-info="ctx.basicInfo" />
  </div>
</template>

<script>
import { fetchHomeData } from "@/api/modules/official/home";
import {
  defaultAboutPage,
  defaultBasicInfo,
  defaultCapabilityValues,
  defaultCoreFeatures,
  defaultCoreValues,
  defaultPartners,
  defaultProducts
} from "@/mock/defaultData";
import OfficialHeader from "./components/OfficialHeader.vue";
import ContactFooter from "./components/ContactFooter.vue";

export default {
  components: {
    OfficialHeader,
    ContactFooter
  },
  provide() {
    return {
      officialShell: this
    };
  },
  data() {
    return {
      ctx: {
        basicInfo: {
          logo: "",
          companyName: ""
        },
        menus: [],
        partners: [],
        products: [],
        coreFeatures: [],
        coreValues: [],
        capabilityValues: [],
        aboutPage: {}
      },
      compactHeader: false,
      isMobile: false,
      mobileDrawerVisible: false
    };
  },
  computed: {
    navItems() {
      const items = (this.ctx.menus || [])
        .filter((m) => String(m.key || "").toLowerCase() !== "/pricing")
        .map((m) => ({
          key: m.key,
          label: m.name
        }));
      const hasCase = items.some((item) => this.normalizePath(item.key) === "/cases");
      if (!hasCase) {
        const caseItem = { key: "/cases", label: "案例" };
        const productIndex = items.findIndex((item) =>
          this.normalizePath(item.key).startsWith("/products")
        );
        if (productIndex >= 0) {
          items.splice(productIndex + 1, 0, caseItem);
        } else {
          items.push(caseItem);
        }
      }
      return items;
    }
  },
  async created() {
    await this.reload();
  },
  mounted() {
    this.updateViewport();
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.updateViewport, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateViewport);
  },
  methods: {
    async reload() {
      const {
        basicInfo,
        menus,
        partners,
        products,
        coreFeatures,
        coreValues,
        capabilityValues,
        aboutPage
      } = await fetchHomeData();
      this.ctx.basicInfo = basicInfo || {};
      this.syncDocumentTitle();
      this.ctx.menus = Array.isArray(menus) ? menus : [];
      this.ctx.partners =
        Array.isArray(partners) && partners.length ? partners : [...defaultPartners];
      this.ctx.products =
        Array.isArray(products) && products.length ? products : [...defaultProducts];
      this.ctx.coreFeatures =
        Array.isArray(coreFeatures) && coreFeatures.length ? coreFeatures : [...defaultCoreFeatures];
      this.ctx.coreValues =
        Array.isArray(coreValues) && coreValues.length ? coreValues : [...defaultCoreValues];
      this.ctx.capabilityValues =
        Array.isArray(capabilityValues) && capabilityValues.length
          ? capabilityValues
          : [...defaultCapabilityValues];
      this.ctx.aboutPage =
        aboutPage && typeof aboutPage === "object"
          ? { ...defaultAboutPage, ...aboutPage }
          : { ...defaultAboutPage };
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
    },
    updateMobileDrawer(visible) {
      this.mobileDrawerVisible = visible;
    },
    syncDocumentTitle() {
      const name = (this.ctx.basicInfo.companyName || defaultBasicInfo.companyName || "").trim();
      if (name) {
        document.title = name;
      }
    },
    normalizePath(path) {
      const str = String(path || "");
      if (!str || str === "/") return "/";
      return str.startsWith("/") ? str : `/${str}`;
    },
    handleScroll() {
      const top = window.scrollY || document.documentElement.scrollTop;
      this.compactHeader = top > 40;
    },
    updateViewport() {
      this.isMobile = window.innerWidth < 992;
    }
  }
};
</script>

<style scoped>
.site {
  min-height: 100vh;
  padding-top: var(--header-h);
  background: var(--bg);
}
</style>
